module.exports = __webpack_public_path__ + "img/titlevi.7db3c196.png";